module.exports = __webpack_public_path__ + "img/inserma.8ad8508f.png";